/**
 * Call It In LLC — Enterprise Sync Service
 * - Handles Timeout & Error Reporting
 * - Formats payload for FastAPI & QuickBooks compatibility
 */

const SYNC_TIMEOUT = 5000; // 5 seconds

export async function syncTasks(tasks = []) {
  // 1. Pull the URL from your environment variables
  const WEBHOOK_URL = process.env.REACT_APP_SYNC_WEBHOOK;

  if (!WEBHOOK_URL) {
    return { success: false, message: "Sync Error: Webhook URL is not configured in .env" };
  }

  // 2. Prepare the payload (Cleaned for Backend consumption)
  const payload = {
    source: "call-it-in-dashboard",
    timestamp: new Date().toISOString(),
    count: tasks.length,
    data: tasks
  };

  // 3. Setup an AbortController (Timeout Protection)
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), SYNC_TIMEOUT);

  try {
    const response = await fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal
    });

    clearTimeout(id);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server Response: ${response.status} - ${errorText}`);
    }

    return { success: true, message: "Sync Successful!" };

  } catch (error) {
    clearTimeout(id);
    const isTimeout = error.name === 'AbortError';
    return { 
      success: false, 
      message: isTimeout ? "Sync Timed Out: Check your Backend/VLAN connection." : error.message 
    };
  }
}
